import { zodRequiredField } from '@/shared/config/zod/schema'
import { z } from 'zod'

export const RestorePasswordByEmailSchema = z.object({
  restoreEmail: zodRequiredField(),
})
